import React from "react";
import { ArrayField, Datagrid, TextField } from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";

const SlotsInfo = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <Grid
      item
      xs={12}
      sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
    >
      <ArrayField
        source="slots"
        label="Часови слотове"
      >
        <Datagrid
          rowClick={false}
          bulkActionButtons={false}
          sx={settings.style.secondaryDatagrid}
        >
          <TextField
            source="startTime"
            label="Начален час"
            sortable={false}
          />
          <TextField
            source="endTime"
            label="Краен час"
            sortable={false}
          />
        </Datagrid>
      </ArrayField>
    </Grid>
  );
};

export default SlotsInfo;
